var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
var defaultOptions = {};
/** The agency activity Type UNSPECIFIED|CREATED|EDITED|DELETED|ENABLED|DISABLED|CONSOLID_FEE_MODULE_EDITED|COMMISSION_MODULE_EDITED */
export var AgencyActivityType;
(function (AgencyActivityType) {
    AgencyActivityType["AgencyActivityTypeCommissionModuleEdited"] = "AGENCY_ACTIVITY_TYPE_COMMISSION_MODULE_EDITED";
    AgencyActivityType["AgencyActivityTypeConsolidFeeModuleEdited"] = "AGENCY_ACTIVITY_TYPE_CONSOLID_FEE_MODULE_EDITED";
    AgencyActivityType["AgencyActivityTypeCreated"] = "AGENCY_ACTIVITY_TYPE_CREATED";
    AgencyActivityType["AgencyActivityTypeDeleted"] = "AGENCY_ACTIVITY_TYPE_DELETED";
    AgencyActivityType["AgencyActivityTypeDisabled"] = "AGENCY_ACTIVITY_TYPE_DISABLED";
    AgencyActivityType["AgencyActivityTypeEdited"] = "AGENCY_ACTIVITY_TYPE_EDITED";
    AgencyActivityType["AgencyActivityTypeEnabled"] = "AGENCY_ACTIVITY_TYPE_ENABLED";
    AgencyActivityType["AgencyActivityTypeUnspecified"] = "AGENCY_ACTIVITY_TYPE_UNSPECIFIED";
})(AgencyActivityType || (AgencyActivityType = {}));
/** The agency commission module activity Type UNSPECIFIED|CREATED|EDITED|DELETED */
export var AgencyCommissionModuleActivityType;
(function (AgencyCommissionModuleActivityType) {
    AgencyCommissionModuleActivityType["AgencyCommissionModuleActivityTypeCreated"] = "AGENCY_COMMISSION_MODULE_ACTIVITY_TYPE_CREATED";
    AgencyCommissionModuleActivityType["AgencyCommissionModuleActivityTypeDeleted"] = "AGENCY_COMMISSION_MODULE_ACTIVITY_TYPE_DELETED";
    AgencyCommissionModuleActivityType["AgencyCommissionModuleActivityTypeEdited"] = "AGENCY_COMMISSION_MODULE_ACTIVITY_TYPE_EDITED";
    AgencyCommissionModuleActivityType["AgencyCommissionModuleActivityTypeUnspecified"] = "AGENCY_COMMISSION_MODULE_ACTIVITY_TYPE_UNSPECIFIED";
})(AgencyCommissionModuleActivityType || (AgencyCommissionModuleActivityType = {}));
/** The agency consolid fee module activity Type UNSPECIFIED|CREATED|EDITED|DELETED */
export var AgencyConsolidFeeModuleActivityType;
(function (AgencyConsolidFeeModuleActivityType) {
    AgencyConsolidFeeModuleActivityType["AgencyConsolidFeeModuleActivityTypeCreated"] = "AGENCY_CONSOLID_FEE_MODULE_ACTIVITY_TYPE_CREATED";
    AgencyConsolidFeeModuleActivityType["AgencyConsolidFeeModuleActivityTypeDeleted"] = "AGENCY_CONSOLID_FEE_MODULE_ACTIVITY_TYPE_DELETED";
    AgencyConsolidFeeModuleActivityType["AgencyConsolidFeeModuleActivityTypeEdited"] = "AGENCY_CONSOLID_FEE_MODULE_ACTIVITY_TYPE_EDITED";
    AgencyConsolidFeeModuleActivityType["AgencyConsolidFeeModuleActivityTypeUnspecified"] = "AGENCY_CONSOLID_FEE_MODULE_ACTIVITY_TYPE_UNSPECIFIED";
})(AgencyConsolidFeeModuleActivityType || (AgencyConsolidFeeModuleActivityType = {}));
/** The contact type AGENT|AGENCY */
export var BookingContactType;
(function (BookingContactType) {
    BookingContactType["BookingContactTypeAgency"] = "BOOKING_CONTACT_TYPE_AGENCY";
    BookingContactType["BookingContactTypeAgent"] = "BOOKING_CONTACT_TYPE_AGENT";
    BookingContactType["BookingContactTypeUnspecified"] = "BOOKING_CONTACT_TYPE_UNSPECIFIED";
})(BookingContactType || (BookingContactType = {}));
/** The role permission */
export var RolePermission;
(function (RolePermission) {
    RolePermission["RolePermissionCreateAgency"] = "ROLE_PERMISSION_CREATE_AGENCY";
    RolePermission["RolePermissionCreateAirline"] = "ROLE_PERMISSION_CREATE_AIRLINE";
    RolePermission["RolePermissionCreateAny"] = "ROLE_PERMISSION_CREATE_ANY";
    RolePermission["RolePermissionCreateAvatarAgency"] = "ROLE_PERMISSION_CREATE_AVATAR_AGENCY";
    RolePermission["RolePermissionCreateAvatarAny"] = "ROLE_PERMISSION_CREATE_AVATAR_ANY";
    RolePermission["RolePermissionCreateBookingAgency"] = "ROLE_PERMISSION_CREATE_BOOKING_AGENCY";
    RolePermission["RolePermissionCreateBookingAny"] = "ROLE_PERMISSION_CREATE_BOOKING_ANY";
    RolePermission["RolePermissionCreateLocation"] = "ROLE_PERMISSION_CREATE_LOCATION";
    RolePermission["RolePermissionCreateOffer"] = "ROLE_PERMISSION_CREATE_OFFER";
    RolePermission["RolePermissionCreateOrderAgency"] = "ROLE_PERMISSION_CREATE_ORDER_AGENCY";
    RolePermission["RolePermissionCreateOrderAny"] = "ROLE_PERMISSION_CREATE_ORDER_ANY";
    RolePermission["RolePermissionCreateTicketAgency"] = "ROLE_PERMISSION_CREATE_TICKET_AGENCY";
    RolePermission["RolePermissionCreateTicketAny"] = "ROLE_PERMISSION_CREATE_TICKET_ANY";
    RolePermission["RolePermissionCreateUserAgency"] = "ROLE_PERMISSION_CREATE_USER_AGENCY";
    RolePermission["RolePermissionCreateUserAny"] = "ROLE_PERMISSION_CREATE_USER_ANY";
    RolePermission["RolePermissionDeleteAgency"] = "ROLE_PERMISSION_DELETE_AGENCY";
    RolePermission["RolePermissionDeleteAirline"] = "ROLE_PERMISSION_DELETE_AIRLINE";
    RolePermission["RolePermissionDeleteAny"] = "ROLE_PERMISSION_DELETE_ANY";
    RolePermission["RolePermissionDeleteAvatarAgency"] = "ROLE_PERMISSION_DELETE_AVATAR_AGENCY";
    RolePermission["RolePermissionDeleteAvatarAny"] = "ROLE_PERMISSION_DELETE_AVATAR_ANY";
    RolePermission["RolePermissionDeleteAvatarOwn"] = "ROLE_PERMISSION_DELETE_AVATAR_OWN";
    RolePermission["RolePermissionDeleteBookingAgency"] = "ROLE_PERMISSION_DELETE_BOOKING_AGENCY";
    RolePermission["RolePermissionDeleteBookingAny"] = "ROLE_PERMISSION_DELETE_BOOKING_ANY";
    RolePermission["RolePermissionDeleteBookingOwn"] = "ROLE_PERMISSION_DELETE_BOOKING_OWN";
    RolePermission["RolePermissionDeleteLocation"] = "ROLE_PERMISSION_DELETE_LOCATION";
    RolePermission["RolePermissionDeleteOffer"] = "ROLE_PERMISSION_DELETE_OFFER";
    RolePermission["RolePermissionDeleteOrderAgency"] = "ROLE_PERMISSION_DELETE_ORDER_AGENCY";
    RolePermission["RolePermissionDeleteOrderAny"] = "ROLE_PERMISSION_DELETE_ORDER_ANY";
    RolePermission["RolePermissionDeleteOrderOwn"] = "ROLE_PERMISSION_DELETE_ORDER_OWN";
    RolePermission["RolePermissionDeleteTicketAgency"] = "ROLE_PERMISSION_DELETE_TICKET_AGENCY";
    RolePermission["RolePermissionDeleteTicketAny"] = "ROLE_PERMISSION_DELETE_TICKET_ANY";
    RolePermission["RolePermissionDeleteTicketOwn"] = "ROLE_PERMISSION_DELETE_TICKET_OWN";
    RolePermission["RolePermissionDeleteUserAgency"] = "ROLE_PERMISSION_DELETE_USER_AGENCY";
    RolePermission["RolePermissionDeleteUserAny"] = "ROLE_PERMISSION_DELETE_USER_ANY";
    RolePermission["RolePermissionDeleteUserOwn"] = "ROLE_PERMISSION_DELETE_USER_OWN";
    RolePermission["RolePermissionReadAgency"] = "ROLE_PERMISSION_READ_AGENCY";
    RolePermission["RolePermissionReadAgencySettings"] = "ROLE_PERMISSION_READ_AGENCY_SETTINGS";
    RolePermission["RolePermissionReadAirline"] = "ROLE_PERMISSION_READ_AIRLINE";
    RolePermission["RolePermissionReadAny"] = "ROLE_PERMISSION_READ_ANY";
    RolePermission["RolePermissionReadAvatarAgency"] = "ROLE_PERMISSION_READ_AVATAR_AGENCY";
    RolePermission["RolePermissionReadAvatarAny"] = "ROLE_PERMISSION_READ_AVATAR_ANY";
    RolePermission["RolePermissionReadAvatarOwn"] = "ROLE_PERMISSION_READ_AVATAR_OWN";
    RolePermission["RolePermissionReadBookingAgency"] = "ROLE_PERMISSION_READ_BOOKING_AGENCY";
    RolePermission["RolePermissionReadBookingAny"] = "ROLE_PERMISSION_READ_BOOKING_ANY";
    RolePermission["RolePermissionReadBookingOwn"] = "ROLE_PERMISSION_READ_BOOKING_OWN";
    RolePermission["RolePermissionReadLocation"] = "ROLE_PERMISSION_READ_LOCATION";
    RolePermission["RolePermissionReadOffer"] = "ROLE_PERMISSION_READ_OFFER";
    RolePermission["RolePermissionReadOrderAgency"] = "ROLE_PERMISSION_READ_ORDER_AGENCY";
    RolePermission["RolePermissionReadOrderAny"] = "ROLE_PERMISSION_READ_ORDER_ANY";
    RolePermission["RolePermissionReadOrderOwn"] = "ROLE_PERMISSION_READ_ORDER_OWN";
    RolePermission["RolePermissionReadTicketAgency"] = "ROLE_PERMISSION_READ_TICKET_AGENCY";
    RolePermission["RolePermissionReadTicketAny"] = "ROLE_PERMISSION_READ_TICKET_ANY";
    RolePermission["RolePermissionReadTicketOwn"] = "ROLE_PERMISSION_READ_TICKET_OWN";
    RolePermission["RolePermissionReadUserAgency"] = "ROLE_PERMISSION_READ_USER_AGENCY";
    RolePermission["RolePermissionReadUserAny"] = "ROLE_PERMISSION_READ_USER_ANY";
    RolePermission["RolePermissionReadUserOwn"] = "ROLE_PERMISSION_READ_USER_OWN";
    RolePermission["RolePermissionUnspecified"] = "ROLE_PERMISSION_UNSPECIFIED";
    RolePermission["RolePermissionUpdateAgency"] = "ROLE_PERMISSION_UPDATE_AGENCY";
    RolePermission["RolePermissionUpdateAirline"] = "ROLE_PERMISSION_UPDATE_AIRLINE";
    RolePermission["RolePermissionUpdateAny"] = "ROLE_PERMISSION_UPDATE_ANY";
    RolePermission["RolePermissionUpdateAvatarAgency"] = "ROLE_PERMISSION_UPDATE_AVATAR_AGENCY";
    RolePermission["RolePermissionUpdateAvatarAny"] = "ROLE_PERMISSION_UPDATE_AVATAR_ANY";
    RolePermission["RolePermissionUpdateAvatarOwn"] = "ROLE_PERMISSION_UPDATE_AVATAR_OWN";
    RolePermission["RolePermissionUpdateBookingAgency"] = "ROLE_PERMISSION_UPDATE_BOOKING_AGENCY";
    RolePermission["RolePermissionUpdateBookingAny"] = "ROLE_PERMISSION_UPDATE_BOOKING_ANY";
    RolePermission["RolePermissionUpdateBookingOwn"] = "ROLE_PERMISSION_UPDATE_BOOKING_OWN";
    RolePermission["RolePermissionUpdateLocation"] = "ROLE_PERMISSION_UPDATE_LOCATION";
    RolePermission["RolePermissionUpdateOffer"] = "ROLE_PERMISSION_UPDATE_OFFER";
    RolePermission["RolePermissionUpdateOrderAgency"] = "ROLE_PERMISSION_UPDATE_ORDER_AGENCY";
    RolePermission["RolePermissionUpdateOrderAny"] = "ROLE_PERMISSION_UPDATE_ORDER_ANY";
    RolePermission["RolePermissionUpdateOrderOwn"] = "ROLE_PERMISSION_UPDATE_ORDER_OWN";
    RolePermission["RolePermissionUpdateTicketAgency"] = "ROLE_PERMISSION_UPDATE_TICKET_AGENCY";
    RolePermission["RolePermissionUpdateTicketAny"] = "ROLE_PERMISSION_UPDATE_TICKET_ANY";
    RolePermission["RolePermissionUpdateTicketOwn"] = "ROLE_PERMISSION_UPDATE_TICKET_OWN";
    RolePermission["RolePermissionUpdateUserAgency"] = "ROLE_PERMISSION_UPDATE_USER_AGENCY";
    RolePermission["RolePermissionUpdateUserAny"] = "ROLE_PERMISSION_UPDATE_USER_ANY";
    RolePermission["RolePermissionUpdateUserOwn"] = "ROLE_PERMISSION_UPDATE_USER_OWN";
})(RolePermission || (RolePermission = {}));
/** The role type */
export var RoleType;
(function (RoleType) {
    RoleType["RoleTypeAdmin"] = "ROLE_TYPE_ADMIN";
    RoleType["RoleTypeAgencyAdmin"] = "ROLE_TYPE_AGENCY_ADMIN";
    RoleType["RoleTypeAgent"] = "ROLE_TYPE_AGENT";
    RoleType["RoleTypeUnspecified"] = "ROLE_TYPE_UNSPECIFIED";
})(RoleType || (RoleType = {}));
export var CreateAgencyCommissionModuleDocument = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  mutation CreateAgencyCommissionModule($values: AgencyCommissionModuleInput!) {\n    createAgencyCommissionModule(values: $values)\n  }\n"], ["\n  mutation CreateAgencyCommissionModule($values: AgencyCommissionModuleInput!) {\n    createAgencyCommissionModule(values: $values)\n  }\n"])));
/**
 * __useCreateAgencyCommissionModuleMutation__
 *
 * To run a mutation, you first call `useCreateAgencyCommissionModuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAgencyCommissionModuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAgencyCommissionModuleMutation, { data, loading, error }] = useCreateAgencyCommissionModuleMutation({
 *   variables: {
 *      values: // value for 'values'
 *   },
 * });
 */
export function useCreateAgencyCommissionModuleMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(CreateAgencyCommissionModuleDocument, options);
}
export var CreateAgencyConsolidFeeModuleDocument = gql(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  mutation CreateAgencyConsolidFeeModule(\n    $values: AgencyConsolidFeeModuleInput!\n  ) {\n    createAgencyConsolidFeeModule(values: $values)\n  }\n"], ["\n  mutation CreateAgencyConsolidFeeModule(\n    $values: AgencyConsolidFeeModuleInput!\n  ) {\n    createAgencyConsolidFeeModule(values: $values)\n  }\n"])));
/**
 * __useCreateAgencyConsolidFeeModuleMutation__
 *
 * To run a mutation, you first call `useCreateAgencyConsolidFeeModuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAgencyConsolidFeeModuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAgencyConsolidFeeModuleMutation, { data, loading, error }] = useCreateAgencyConsolidFeeModuleMutation({
 *   variables: {
 *      values: // value for 'values'
 *   },
 * });
 */
export function useCreateAgencyConsolidFeeModuleMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(CreateAgencyConsolidFeeModuleDocument, options);
}
export var CreateAgencyDocument = gql(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  mutation CreateAgency($values: AgencyInput!) {\n    createAgency(values: $values) {\n      id\n    }\n  }\n"], ["\n  mutation CreateAgency($values: AgencyInput!) {\n    createAgency(values: $values) {\n      id\n    }\n  }\n"])));
/**
 * __useCreateAgencyMutation__
 *
 * To run a mutation, you first call `useCreateAgencyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAgencyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAgencyMutation, { data, loading, error }] = useCreateAgencyMutation({
 *   variables: {
 *      values: // value for 'values'
 *   },
 * });
 */
export function useCreateAgencyMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(CreateAgencyDocument, options);
}
export var CreateUserDocument = gql(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  mutation CreateUser($user: UserInput!) {\n    createUser(user: $user)\n  }\n"], ["\n  mutation CreateUser($user: UserInput!) {\n    createUser(user: $user)\n  }\n"])));
/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      user: // value for 'user'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(CreateUserDocument, options);
}
export var DeleteAgencyCommissionModuleDocument = gql(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  mutation DeleteAgencyCommissionModule(\n    $deleteAgencyCommissionModuleId: Float!\n  ) {\n    deleteAgencyCommissionModule(id: $deleteAgencyCommissionModuleId)\n  }\n"], ["\n  mutation DeleteAgencyCommissionModule(\n    $deleteAgencyCommissionModuleId: Float!\n  ) {\n    deleteAgencyCommissionModule(id: $deleteAgencyCommissionModuleId)\n  }\n"])));
/**
 * __useDeleteAgencyCommissionModuleMutation__
 *
 * To run a mutation, you first call `useDeleteAgencyCommissionModuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAgencyCommissionModuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAgencyCommissionModuleMutation, { data, loading, error }] = useDeleteAgencyCommissionModuleMutation({
 *   variables: {
 *      deleteAgencyCommissionModuleId: // value for 'deleteAgencyCommissionModuleId'
 *   },
 * });
 */
export function useDeleteAgencyCommissionModuleMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(DeleteAgencyCommissionModuleDocument, options);
}
export var DeleteAgencyConsolidFeeModuleDocument = gql(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  mutation DeleteAgencyConsolidFeeModule(\n    $deleteAgencyConsolidFeeModuleId: Float!\n  ) {\n    deleteAgencyConsolidFeeModule(id: $deleteAgencyConsolidFeeModuleId)\n  }\n"], ["\n  mutation DeleteAgencyConsolidFeeModule(\n    $deleteAgencyConsolidFeeModuleId: Float!\n  ) {\n    deleteAgencyConsolidFeeModule(id: $deleteAgencyConsolidFeeModuleId)\n  }\n"])));
/**
 * __useDeleteAgencyConsolidFeeModuleMutation__
 *
 * To run a mutation, you first call `useDeleteAgencyConsolidFeeModuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAgencyConsolidFeeModuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAgencyConsolidFeeModuleMutation, { data, loading, error }] = useDeleteAgencyConsolidFeeModuleMutation({
 *   variables: {
 *      deleteAgencyConsolidFeeModuleId: // value for 'deleteAgencyConsolidFeeModuleId'
 *   },
 * });
 */
export function useDeleteAgencyConsolidFeeModuleMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(DeleteAgencyConsolidFeeModuleDocument, options);
}
export var DeleteAgencyDocument = gql(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  mutation DeleteAgency($deleteAgencyId2: Float!) {\n    deleteAgency(id: $deleteAgencyId2)\n  }\n"], ["\n  mutation DeleteAgency($deleteAgencyId2: Float!) {\n    deleteAgency(id: $deleteAgencyId2)\n  }\n"])));
/**
 * __useDeleteAgencyMutation__
 *
 * To run a mutation, you first call `useDeleteAgencyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAgencyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAgencyMutation, { data, loading, error }] = useDeleteAgencyMutation({
 *   variables: {
 *      deleteAgencyId2: // value for 'deleteAgencyId2'
 *   },
 * });
 */
export function useDeleteAgencyMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(DeleteAgencyDocument, options);
}
export var DeleteUserDocument = gql(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  mutation DeleteUser($deleteUserId: Float!) {\n    deleteUser(id: $deleteUserId)\n  }\n"], ["\n  mutation DeleteUser($deleteUserId: Float!) {\n    deleteUser(id: $deleteUserId)\n  }\n"])));
/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserMutation, { data, loading, error }] = useDeleteUserMutation({
 *   variables: {
 *      deleteUserId: // value for 'deleteUserId'
 *   },
 * });
 */
export function useDeleteUserMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(DeleteUserDocument, options);
}
export var DisableAgencyDocument = gql(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  mutation DisableAgency($disableAgencyId: Float!) {\n    disableAgency(id: $disableAgencyId)\n  }\n"], ["\n  mutation DisableAgency($disableAgencyId: Float!) {\n    disableAgency(id: $disableAgencyId)\n  }\n"])));
/**
 * __useDisableAgencyMutation__
 *
 * To run a mutation, you first call `useDisableAgencyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableAgencyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableAgencyMutation, { data, loading, error }] = useDisableAgencyMutation({
 *   variables: {
 *      disableAgencyId: // value for 'disableAgencyId'
 *   },
 * });
 */
export function useDisableAgencyMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(DisableAgencyDocument, options);
}
export var EnableAgencyDocument = gql(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  mutation EnableAgency($enableAgencyId: Float!) {\n    enableAgency(id: $enableAgencyId)\n  }\n"], ["\n  mutation EnableAgency($enableAgencyId: Float!) {\n    enableAgency(id: $enableAgencyId)\n  }\n"])));
/**
 * __useEnableAgencyMutation__
 *
 * To run a mutation, you first call `useEnableAgencyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableAgencyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableAgencyMutation, { data, loading, error }] = useEnableAgencyMutation({
 *   variables: {
 *      enableAgencyId: // value for 'enableAgencyId'
 *   },
 * });
 */
export function useEnableAgencyMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(EnableAgencyDocument, options);
}
export var PutAgencyCommissionModuleDocument = gql(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  mutation PutAgencyCommissionModule($values: AgencyCommissionModuleValues!) {\n    putAgencyCommissionModule(values: $values)\n  }\n"], ["\n  mutation PutAgencyCommissionModule($values: AgencyCommissionModuleValues!) {\n    putAgencyCommissionModule(values: $values)\n  }\n"])));
/**
 * __usePutAgencyCommissionModuleMutation__
 *
 * To run a mutation, you first call `usePutAgencyCommissionModuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePutAgencyCommissionModuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [putAgencyCommissionModuleMutation, { data, loading, error }] = usePutAgencyCommissionModuleMutation({
 *   variables: {
 *      values: // value for 'values'
 *   },
 * });
 */
export function usePutAgencyCommissionModuleMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(PutAgencyCommissionModuleDocument, options);
}
export var PutAgencyConsolidFeeModuleDocument = gql(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n  mutation PutAgencyConsolidFeeModule($values: AgencyConsolidFeeModuleValues!) {\n    putAgencyConsolidFeeModule(values: $values)\n  }\n"], ["\n  mutation PutAgencyConsolidFeeModule($values: AgencyConsolidFeeModuleValues!) {\n    putAgencyConsolidFeeModule(values: $values)\n  }\n"])));
/**
 * __usePutAgencyConsolidFeeModuleMutation__
 *
 * To run a mutation, you first call `usePutAgencyConsolidFeeModuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePutAgencyConsolidFeeModuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [putAgencyConsolidFeeModuleMutation, { data, loading, error }] = usePutAgencyConsolidFeeModuleMutation({
 *   variables: {
 *      values: // value for 'values'
 *   },
 * });
 */
export function usePutAgencyConsolidFeeModuleMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(PutAgencyConsolidFeeModuleDocument, options);
}
export var UpdateAgencyDocument = gql(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n  mutation UpdateAgency($values: AgencyValues!, $updateAgencyId: Float!) {\n    updateAgency(values: $values, id: $updateAgencyId) {\n      id\n    }\n  }\n"], ["\n  mutation UpdateAgency($values: AgencyValues!, $updateAgencyId: Float!) {\n    updateAgency(values: $values, id: $updateAgencyId) {\n      id\n    }\n  }\n"])));
/**
 * __useUpdateAgencyMutation__
 *
 * To run a mutation, you first call `useUpdateAgencyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAgencyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAgencyMutation, { data, loading, error }] = useUpdateAgencyMutation({
 *   variables: {
 *      values: // value for 'values'
 *      updateAgencyId: // value for 'updateAgencyId'
 *   },
 * });
 */
export function useUpdateAgencyMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(UpdateAgencyDocument, options);
}
export var UpdateUserDocument = gql(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n  mutation UpdateUser($values: UserValues!, $email: String!) {\n    updateUser(values: $values, email: $email) {\n      id\n    }\n  }\n"], ["\n  mutation UpdateUser($values: UserValues!, $email: String!) {\n    updateUser(values: $values, email: $email) {\n      id\n    }\n  }\n"])));
/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      values: // value for 'values'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(UpdateUserDocument, options);
}
export var GetAgenciesSearchDocument = gql(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n  query GetAgenciesSearch($input: String!) {\n    readAgenciesSearch(input: $input) @client {\n      id\n      created_at\n      name\n      crm_company_id\n      enabled\n      last_activity\n      logo {\n        medium_uri\n      }\n    }\n  }\n"], ["\n  query GetAgenciesSearch($input: String!) {\n    readAgenciesSearch(input: $input) @client {\n      id\n      created_at\n      name\n      crm_company_id\n      enabled\n      last_activity\n      logo {\n        medium_uri\n      }\n    }\n  }\n"])));
/**
 * __useGetAgenciesSearchQuery__
 *
 * To run a query within a React component, call `useGetAgenciesSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgenciesSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgenciesSearchQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAgenciesSearchQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetAgenciesSearchDocument, options);
}
export function useGetAgenciesSearchLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetAgenciesSearchDocument, options);
}
export var GetAgenciesDocument = gql(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n  query GetAgencies {\n    getAgencies {\n      id\n      created_at\n      name\n      crm_company_id\n      enabled\n      last_activity\n      logo {\n        medium_uri\n      }\n    }\n  }\n"], ["\n  query GetAgencies {\n    getAgencies {\n      id\n      created_at\n      name\n      crm_company_id\n      enabled\n      last_activity\n      logo {\n        medium_uri\n      }\n    }\n  }\n"])));
/**
 * __useGetAgenciesQuery__
 *
 * To run a query within a React component, call `useGetAgenciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgenciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgenciesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAgenciesQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetAgenciesDocument, options);
}
export function useGetAgenciesLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetAgenciesDocument, options);
}
export var GetAgencyActivitiesDocument = gql(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n  query GetAgencyActivities($getAgencyId: Float!) {\n    getAgencyActivities: getAgency(id: $getAgencyId) {\n      activities {\n        activity_type\n        id\n        created_at\n        agency_id\n        user_agency_id\n        user_id\n        err\n        transaction\n        user_info {\n          first_name\n          last_name\n        }\n      }\n    }\n  }\n"], ["\n  query GetAgencyActivities($getAgencyId: Float!) {\n    getAgencyActivities: getAgency(id: $getAgencyId) {\n      activities {\n        activity_type\n        id\n        created_at\n        agency_id\n        user_agency_id\n        user_id\n        err\n        transaction\n        user_info {\n          first_name\n          last_name\n        }\n      }\n    }\n  }\n"])));
/**
 * __useGetAgencyActivitiesQuery__
 *
 * To run a query within a React component, call `useGetAgencyActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgencyActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgencyActivitiesQuery({
 *   variables: {
 *      getAgencyId: // value for 'getAgencyId'
 *   },
 * });
 */
export function useGetAgencyActivitiesQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetAgencyActivitiesDocument, options);
}
export function useGetAgencyActivitiesLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetAgencyActivitiesDocument, options);
}
export var GetCommissionModuleAgenciesDocument = gql(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n  query GetCommissionModuleAgencies($getAgencyCommissionModuleId: Float) {\n    getAgencyCommissionModule(id: $getAgencyCommissionModuleId) {\n      agencies {\n        id\n        name\n        logo {\n          small_uri\n        }\n      }\n    }\n  }\n"], ["\n  query GetCommissionModuleAgencies($getAgencyCommissionModuleId: Float) {\n    getAgencyCommissionModule(id: $getAgencyCommissionModuleId) {\n      agencies {\n        id\n        name\n        logo {\n          small_uri\n        }\n      }\n    }\n  }\n"])));
/**
 * __useGetCommissionModuleAgenciesQuery__
 *
 * To run a query within a React component, call `useGetCommissionModuleAgenciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommissionModuleAgenciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommissionModuleAgenciesQuery({
 *   variables: {
 *      getAgencyCommissionModuleId: // value for 'getAgencyCommissionModuleId'
 *   },
 * });
 */
export function useGetCommissionModuleAgenciesQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetCommissionModuleAgenciesDocument, options);
}
export function useGetCommissionModuleAgenciesLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetCommissionModuleAgenciesDocument, options);
}
export var GetAgencyCommissionModuleDocument = gql(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n  query GetAgencyCommissionModule($getAgencyCommissionModuleId: Float) {\n    getAgencyCommissionModule(id: $getAgencyCommissionModuleId) {\n      id\n      name\n      created_at\n      description\n      airlines_commissions {\n        id\n        airline_code\n        from_commission\n        to_commission\n        consolid_commission\n      }\n    }\n  }\n"], ["\n  query GetAgencyCommissionModule($getAgencyCommissionModuleId: Float) {\n    getAgencyCommissionModule(id: $getAgencyCommissionModuleId) {\n      id\n      name\n      created_at\n      description\n      airlines_commissions {\n        id\n        airline_code\n        from_commission\n        to_commission\n        consolid_commission\n      }\n    }\n  }\n"])));
/**
 * __useGetAgencyCommissionModuleQuery__
 *
 * To run a query within a React component, call `useGetAgencyCommissionModuleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgencyCommissionModuleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgencyCommissionModuleQuery({
 *   variables: {
 *      getAgencyCommissionModuleId: // value for 'getAgencyCommissionModuleId'
 *   },
 * });
 */
export function useGetAgencyCommissionModuleQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetAgencyCommissionModuleDocument, options);
}
export function useGetAgencyCommissionModuleLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetAgencyCommissionModuleDocument, options);
}
export var GetAgencyCommissionModulesDocument = gql(templateObject_20 || (templateObject_20 = __makeTemplateObject(["\n  query GetAgencyCommissionModules {\n    getAgencyCommissionModules {\n      id\n      name\n      description\n    }\n  }\n"], ["\n  query GetAgencyCommissionModules {\n    getAgencyCommissionModules {\n      id\n      name\n      description\n    }\n  }\n"])));
/**
 * __useGetAgencyCommissionModulesQuery__
 *
 * To run a query within a React component, call `useGetAgencyCommissionModulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgencyCommissionModulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgencyCommissionModulesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAgencyCommissionModulesQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetAgencyCommissionModulesDocument, options);
}
export function useGetAgencyCommissionModulesLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetAgencyCommissionModulesDocument, options);
}
export var GetConsolidFeeModuleAgenciesDocument = gql(templateObject_21 || (templateObject_21 = __makeTemplateObject(["\n  query GetConsolidFeeModuleAgencies($getAgencyConsolidFeeModuleId: Float) {\n    getAgencyConsolidFeeModule(id: $getAgencyConsolidFeeModuleId) {\n      agencies {\n        id\n        name\n        logo {\n          small_uri\n        }\n      }\n    }\n  }\n"], ["\n  query GetConsolidFeeModuleAgencies($getAgencyConsolidFeeModuleId: Float) {\n    getAgencyConsolidFeeModule(id: $getAgencyConsolidFeeModuleId) {\n      agencies {\n        id\n        name\n        logo {\n          small_uri\n        }\n      }\n    }\n  }\n"])));
/**
 * __useGetConsolidFeeModuleAgenciesQuery__
 *
 * To run a query within a React component, call `useGetConsolidFeeModuleAgenciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConsolidFeeModuleAgenciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConsolidFeeModuleAgenciesQuery({
 *   variables: {
 *      getAgencyConsolidFeeModuleId: // value for 'getAgencyConsolidFeeModuleId'
 *   },
 * });
 */
export function useGetConsolidFeeModuleAgenciesQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetConsolidFeeModuleAgenciesDocument, options);
}
export function useGetConsolidFeeModuleAgenciesLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetConsolidFeeModuleAgenciesDocument, options);
}
export var GetAgencyConsolidFeeModuleDocument = gql(templateObject_22 || (templateObject_22 = __makeTemplateObject(["\n  query GetAgencyConsolidFeeModule($getAgencyConsolidFeeModuleId: Float) {\n    getAgencyConsolidFeeModule(id: $getAgencyConsolidFeeModuleId) {\n      name\n      id\n      description\n      economy_consolid_fee\n      created_at\n      business_consolid_fee\n    }\n  }\n"], ["\n  query GetAgencyConsolidFeeModule($getAgencyConsolidFeeModuleId: Float) {\n    getAgencyConsolidFeeModule(id: $getAgencyConsolidFeeModuleId) {\n      name\n      id\n      description\n      economy_consolid_fee\n      created_at\n      business_consolid_fee\n    }\n  }\n"])));
/**
 * __useGetAgencyConsolidFeeModuleQuery__
 *
 * To run a query within a React component, call `useGetAgencyConsolidFeeModuleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgencyConsolidFeeModuleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgencyConsolidFeeModuleQuery({
 *   variables: {
 *      getAgencyConsolidFeeModuleId: // value for 'getAgencyConsolidFeeModuleId'
 *   },
 * });
 */
export function useGetAgencyConsolidFeeModuleQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetAgencyConsolidFeeModuleDocument, options);
}
export function useGetAgencyConsolidFeeModuleLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetAgencyConsolidFeeModuleDocument, options);
}
export var GetAgencyDocument = gql(templateObject_23 || (templateObject_23 = __makeTemplateObject(["\n  query GetAgency($getAgencyId: Float!) {\n    getAgency(id: $getAgencyId) {\n      id\n      created_at\n      name\n      email\n      phone_number\n      default_business_fee\n      default_economy_fee\n      booking_contact_type\n      logo {\n        mime_type\n        small_uri\n        medium_uri\n        large_uri\n        original_uri\n      }\n      commission_module\n      consolid_fee_module\n      crm_company_id\n      enabled\n    }\n  }\n"], ["\n  query GetAgency($getAgencyId: Float!) {\n    getAgency(id: $getAgencyId) {\n      id\n      created_at\n      name\n      email\n      phone_number\n      default_business_fee\n      default_economy_fee\n      booking_contact_type\n      logo {\n        mime_type\n        small_uri\n        medium_uri\n        large_uri\n        original_uri\n      }\n      commission_module\n      consolid_fee_module\n      crm_company_id\n      enabled\n    }\n  }\n"])));
/**
 * __useGetAgencyQuery__
 *
 * To run a query within a React component, call `useGetAgencyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgencyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgencyQuery({
 *   variables: {
 *      getAgencyId: // value for 'getAgencyId'
 *   },
 * });
 */
export function useGetAgencyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetAgencyDocument, options);
}
export function useGetAgencyLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetAgencyDocument, options);
}
export var AirlinesDocument = gql(templateObject_24 || (templateObject_24 = __makeTemplateObject(["\n  query Airlines {\n    airlines {\n      short_name\n      long_name\n      code\n    }\n  }\n"], ["\n  query Airlines {\n    airlines {\n      short_name\n      long_name\n      code\n    }\n  }\n"])));
/**
 * __useAirlinesQuery__
 *
 * To run a query within a React component, call `useAirlinesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAirlinesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAirlinesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAirlinesQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(AirlinesDocument, options);
}
export function useAirlinesLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(AirlinesDocument, options);
}
export var GetAgencyCommissionModuleActivitiesDocument = gql(templateObject_25 || (templateObject_25 = __makeTemplateObject(["\n  query GetAgencyCommissionModuleActivities(\n    $getAgencyCommissionModuleId: Float\n  ) {\n    getCommissionModuleActivities: getAgencyCommissionModule(\n      id: $getAgencyCommissionModuleId\n    ) {\n      id\n      activities {\n        activity_type\n        id\n        created_at\n        agency_id\n        commission_module_id\n        user_id\n        err\n        transaction\n        agency_info {\n          name\n        }\n        user_info {\n          first_name\n          last_name\n          email\n          id\n        }\n      }\n    }\n  }\n"], ["\n  query GetAgencyCommissionModuleActivities(\n    $getAgencyCommissionModuleId: Float\n  ) {\n    getCommissionModuleActivities: getAgencyCommissionModule(\n      id: $getAgencyCommissionModuleId\n    ) {\n      id\n      activities {\n        activity_type\n        id\n        created_at\n        agency_id\n        commission_module_id\n        user_id\n        err\n        transaction\n        agency_info {\n          name\n        }\n        user_info {\n          first_name\n          last_name\n          email\n          id\n        }\n      }\n    }\n  }\n"])));
/**
 * __useGetAgencyCommissionModuleActivitiesQuery__
 *
 * To run a query within a React component, call `useGetAgencyCommissionModuleActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgencyCommissionModuleActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgencyCommissionModuleActivitiesQuery({
 *   variables: {
 *      getAgencyCommissionModuleId: // value for 'getAgencyCommissionModuleId'
 *   },
 * });
 */
export function useGetAgencyCommissionModuleActivitiesQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetAgencyCommissionModuleActivitiesDocument, options);
}
export function useGetAgencyCommissionModuleActivitiesLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetAgencyCommissionModuleActivitiesDocument, options);
}
export var GetAgencyConsolidFeeModuleActivitiesDocument = gql(templateObject_26 || (templateObject_26 = __makeTemplateObject(["\n  query GetAgencyConsolidFeeModuleActivities(\n    $getAgencyConsolidFeeModuleId: Float\n  ) {\n    getConsolidFeeModuleActivities: getAgencyConsolidFeeModule(\n      id: $getAgencyConsolidFeeModuleId\n    ) {\n      id\n      activities {\n        activity_type\n        agency_consolid_fee_module_id\n        agency_id\n        agency_info {\n          name\n        }\n        created_at\n        err\n        id\n        transaction\n        user_info {\n          first_name\n          last_name\n          email\n          id\n        }\n      }\n    }\n  }\n"], ["\n  query GetAgencyConsolidFeeModuleActivities(\n    $getAgencyConsolidFeeModuleId: Float\n  ) {\n    getConsolidFeeModuleActivities: getAgencyConsolidFeeModule(\n      id: $getAgencyConsolidFeeModuleId\n    ) {\n      id\n      activities {\n        activity_type\n        agency_consolid_fee_module_id\n        agency_id\n        agency_info {\n          name\n        }\n        created_at\n        err\n        id\n        transaction\n        user_info {\n          first_name\n          last_name\n          email\n          id\n        }\n      }\n    }\n  }\n"])));
/**
 * __useGetAgencyConsolidFeeModuleActivitiesQuery__
 *
 * To run a query within a React component, call `useGetAgencyConsolidFeeModuleActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgencyConsolidFeeModuleActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgencyConsolidFeeModuleActivitiesQuery({
 *   variables: {
 *      getAgencyConsolidFeeModuleId: // value for 'getAgencyConsolidFeeModuleId'
 *   },
 * });
 */
export function useGetAgencyConsolidFeeModuleActivitiesQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetAgencyConsolidFeeModuleActivitiesDocument, options);
}
export function useGetAgencyConsolidFeeModuleActivitiesLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetAgencyConsolidFeeModuleActivitiesDocument, options);
}
export var GetAgencyConsolidFeeModulesDocument = gql(templateObject_27 || (templateObject_27 = __makeTemplateObject(["\n  query GetAgencyConsolidFeeModules {\n    getAgencyConsolidFeeModules {\n      id\n      name\n      description\n    }\n  }\n"], ["\n  query GetAgencyConsolidFeeModules {\n    getAgencyConsolidFeeModules {\n      id\n      name\n      description\n    }\n  }\n"])));
/**
 * __useGetAgencyConsolidFeeModulesQuery__
 *
 * To run a query within a React component, call `useGetAgencyConsolidFeeModulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgencyConsolidFeeModulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgencyConsolidFeeModulesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAgencyConsolidFeeModulesQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetAgencyConsolidFeeModulesDocument, options);
}
export function useGetAgencyConsolidFeeModulesLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetAgencyConsolidFeeModulesDocument, options);
}
export var GetDisabledAgenciesDocument = gql(templateObject_28 || (templateObject_28 = __makeTemplateObject(["\n  query GetDisabledAgencies {\n    readDisabledAgencies @client {\n      id\n      created_at\n      name\n      crm_company_id\n      enabled\n      last_activity\n      logo {\n        medium_uri\n      }\n    }\n  }\n"], ["\n  query GetDisabledAgencies {\n    readDisabledAgencies @client {\n      id\n      created_at\n      name\n      crm_company_id\n      enabled\n      last_activity\n      logo {\n        medium_uri\n      }\n    }\n  }\n"])));
/**
 * __useGetDisabledAgenciesQuery__
 *
 * To run a query within a React component, call `useGetDisabledAgenciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDisabledAgenciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDisabledAgenciesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDisabledAgenciesQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetDisabledAgenciesDocument, options);
}
export function useGetDisabledAgenciesLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetDisabledAgenciesDocument, options);
}
export var GetEnabledAgenciesDocument = gql(templateObject_29 || (templateObject_29 = __makeTemplateObject(["\n  query GetEnabledAgencies {\n    readEnabledAgencies @client {\n      id\n      created_at\n      name\n      crm_company_id\n      enabled\n      last_activity\n      logo {\n        medium_uri\n      }\n    }\n  }\n"], ["\n  query GetEnabledAgencies {\n    readEnabledAgencies @client {\n      id\n      created_at\n      name\n      crm_company_id\n      enabled\n      last_activity\n      logo {\n        medium_uri\n      }\n    }\n  }\n"])));
/**
 * __useGetEnabledAgenciesQuery__
 *
 * To run a query within a React component, call `useGetEnabledAgenciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEnabledAgenciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEnabledAgenciesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEnabledAgenciesQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetEnabledAgenciesDocument, options);
}
export function useGetEnabledAgenciesLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetEnabledAgenciesDocument, options);
}
export var GetUserDocument = gql(templateObject_30 || (templateObject_30 = __makeTemplateObject(["\n  query GetUser($getUserId: Float) {\n    getUser(id: $getUserId) {\n      id\n      first_name\n      middle_name\n      last_name\n      email\n      phone_number\n      roles\n      avatar {\n        small_uri\n      }\n    }\n  }\n"], ["\n  query GetUser($getUserId: Float) {\n    getUser(id: $getUserId) {\n      id\n      first_name\n      middle_name\n      last_name\n      email\n      phone_number\n      roles\n      avatar {\n        small_uri\n      }\n    }\n  }\n"])));
/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *      getUserId: // value for 'getUserId'
 *   },
 * });
 */
export function useGetUserQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetUserDocument, options);
}
export function useGetUserLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetUserDocument, options);
}
export var GetUsersDocument = gql(templateObject_31 || (templateObject_31 = __makeTemplateObject(["\n  query GetUsers($filter: UserFilter) {\n    getUsers(filter: $filter) {\n      id\n      email\n      first_name\n      middle_name\n      last_name\n      last_activity\n      agency_id\n    }\n  }\n"], ["\n  query GetUsers($filter: UserFilter) {\n    getUsers(filter: $filter) {\n      id\n      email\n      first_name\n      middle_name\n      last_name\n      last_activity\n      agency_id\n    }\n  }\n"])));
/**
 * __useGetUsersQuery__
 *
 * To run a query within a React component, call `useGetUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetUsersQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetUsersDocument, options);
}
export function useGetUsersLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetUsersDocument, options);
}
export var SearchAirlinesDocument = gql(templateObject_32 || (templateObject_32 = __makeTemplateObject(["\n  query SearchAirlines($query: String!) {\n    searchAirlines(query: $query) {\n      code\n      short_name\n      long_name\n    }\n  }\n"], ["\n  query SearchAirlines($query: String!) {\n    searchAirlines(query: $query) {\n      code\n      short_name\n      long_name\n    }\n  }\n"])));
/**
 * __useSearchAirlinesQuery__
 *
 * To run a query within a React component, call `useSearchAirlinesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchAirlinesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchAirlinesQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useSearchAirlinesQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(SearchAirlinesDocument, options);
}
export function useSearchAirlinesLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(SearchAirlinesDocument, options);
}
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30, templateObject_31, templateObject_32;
